/** Production CSS can serialize a millisecond token in seconds. */
export function motionDuration(element: Element, token = '--dur-2') {
  const value = getComputedStyle(element).getPropertyValue(token).trim();
  return parseFloat(value) * (value.endsWith('ms') ? 1 : 1000);
}
